import { Navigate } from "react-router-dom";
import { useSales } from "@/lib/sales";
import { useBackState } from "@/hooks/useScrollMemory";
import { RecommendedTab } from "@/components/sales/RecommendedTab";
import { QueueTab } from "@/components/sales/QueueTab";
import { RulesTab } from "@/components/sales/RulesTab";
import { DraftView } from "@/components/sales/draft/DraftView";
import { BadgeDollarSign, Loader2 } from "lucide-react";

// STAGE 2 · SALES MANAGEMENT — the one new area (B2.1), one entry in the menu, its tabs inside. Absent while Stage 2
// is switched off, or for someone holding none of the six Sales permissions. Rules only with "Set sales rules".
export default function SalesPage() {
  const sales = useSales();
  const [tab, setTab] = useBackState("tab", "recommended");
  const [draft, setDraft] = useBackState("draft", "");     // S2.3: a listing draft opens from its queue row
  if (!sales.ready) return <div className="py-16 text-center"><Loader2 className="w-5 h-5 animate-spin mx-auto text-slate-400" /></div>;
  if (!sales.any) return <Navigate to="/home" replace />;
  const tabs = [["recommended", "Recommended to sell"], ["queue", "Queue"]].concat(sales.caps.set_sales_rules ? [["rules", "Rules"]] : []);
  const shown = tabs.some(([k]) => k === tab) ? tab : "recommended";
  return (
    <div data-testid="sales-page" className={`${draft ? "max-w-6xl" : "max-w-4xl"} space-y-5`}>
      <div>
        <h1 className="font-display text-2xl font-bold tracking-tight flex items-center gap-2"><BadgeDollarSign className="w-5 h-5 text-[#B01E28]" />Sales Management</h1>
        <p className="text-sm text-slate-500 mt-1">Only complete items can go up for sale. Nothing here changes the part or truck itself, and every action has Undo.</p>
      </div>
      <div role="tablist" className="flex gap-1 border-b border-slate-200">
        {tabs.map(([k, w]) => (
          <button key={k} type="button" role="tab" aria-selected={shown === k} data-testid={`sales-tab-${k}`} onClick={() => { setTab(k); setDraft(""); }}
            className={`h-11 px-4 -mb-px border-b-2 text-sm font-bold ${shown === k ? "border-[#B01E28] text-slate-900" : "border-transparent text-slate-500 hover:text-slate-800"}`}>{w}</button>
        ))}
      </div>
      {draft ? <DraftView kind={draft.split(":")[0]} id={draft.split(":")[1]} onClose={() => setDraft("")} />
        : shown === "queue" ? <QueueTab onOpen={(k) => { setTab("queue"); setDraft(k); }} /> : shown === "rules" ? <RulesTab /> : <RecommendedTab caps={sales.caps} />}
    </div>
  );
}
